module.exports = __webpack_public_path__ + "img/Path 28 Copy@3x.c80d8f93.png";